module.exports = __webpack_public_path__ + "static/story5-thumbnails-rect-250x125-2ce88979542a8d5fdbd86c69a0dcb921.jpg";